import {FC} from 'react'
import {useParams} from 'react-router-dom'
import {useQuery} from 'react-query'
import {TaskCloneModalForm} from './TaskCloneModalForm'
import {ID, isNotEmpty, KTCardBody, QUERIES} from '../../../../../../_metronic/helpers'
import {useListView} from '../core/ListViewProvider'
import {getTaskById} from '../core/_requests'
import {Loading} from '../../../../../../_metronic/partials/components/loading/Loading'
import {getServerErrorMessage} from '../../../../../../_metronic/helpers/apiError'
import {Toast} from '../../../../../../_metronic/partials/widgets'

type Props = {
  handleClose: () => void | undefined
  taskId: ID
}

const TaskCloneModalFormWrapper: FC<Props> = ({handleClose, taskId}) => {
  const {
    isLoading,
    data: task,
    error,
  } = useQuery(
    `${QUERIES.TASKS_LIST}-task-${taskId}`,
    () => {
      return getTaskById(taskId)
    },
    {
      // Ao fechar, o cloneTaskId sai da URL antes de o modal desmontar (animação): sem isso, busca /tarefas/null.
      enabled: !!taskId,
      // Mantém o formulário na tela durante o fade-out, em vez de piscar o loading.
      keepPreviousData: true,
      cacheTime: 0,
      refetchOnWindowFocus: false,
      // Sem isso o erro ficava num loading infinito (com 3 novas tentativas antes): avisa e fecha o modal.
      retry: false,
      onError: (err) => {
        Toast.fire({
          icon: 'warning',
          title: getServerErrorMessage(err) ?? 'Não foi possível carregar a tarefa para clonar.',
          timer: 8000,
          customClass: {
            popup: 'bg-light-danger',
            title: 'text-danger',
          },
        })
        handleClose()
      },
    }
  )

  // Dado anterior só vale no fechamento (sem id); com outro id, espera a tarefa certa chegar.
  const isTaskForThisId = !taskId || String(task?.tasks?.id) === String(taskId)

  if (error) {
    return null
  }

  if (!isLoading && task && isTaskForThisId) {
    return <TaskCloneModalForm isTaskLoading={isLoading} handleClose={handleClose} task={task} />
  } else {
    return <Loading />
  }

  return null
}

export {TaskCloneModalFormWrapper}
